/**
 * Client Relationship Manager API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Resource type that this metadata schema is allowed to be added to.
 * @export
 * @enum {string}
 */
export enum ResourceType {
	Client = 'client',
	ClientContact = 'client_contact',
	ClientServicecontact = 'client_servicecontact',
}

export function ResourceTypeFromJSON(json: any): ResourceType {
	return ResourceTypeFromJSONTyped(json, false);
}

export function ResourceTypeFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ResourceType {
	return json as ResourceType;
}

export function ResourceTypeToJSON(value?: ResourceType | null): any {
	return value as any;
}
